let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jR6AZ")).then(() => parcelRequire('crVy2'));